import type { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { conversationStartersKey } from '@core/tellent-assistant-types';

import { ConversationStartersHttp } from './conversation-starters.http';
import { ConversationStartersActions } from './conversation-starters.state';

export const loadConversationStarters = createEffect(
  (actions$ = inject(Actions), http = inject(ConversationStartersHttp)) =>
    actions$.pipe(
      ofType(ConversationStartersActions.fetchOne),
      switchMap(action => {
        const ctx = action.payload.ctx;
        const id = conversationStartersKey(ctx);
        return http.fetch(ctx).pipe(
          map(data =>
            ConversationStartersActions.fetchOneSuccess({
              payload: { data: { ...data, id } },
            }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(
              ConversationStartersActions.fetchOneFailed({
                payload: { id, error },
              }),
            ),
          ),
        );
      }),
    ),
  { functional: true },
);
